import PageBanner from "../components/ui/PageBanner";
import wellnessImg from "../assets/about-wellness.jpeg";
import achieveImg from "../assets/about-achieve.jpeg";
import heroOne from "../assets/header-1.jpeg";
import heroTwo from "../assets/header-2.jpeg";
import "./About.css";

export default function HospitalGallery() {
  return (
    <div className="about-page">
      <PageBanner title="Hospital Tour" crumbs={["Home", "About", "Hospital Tour"]} />

      <section className="section section--gray">
        <div className="section-inner">
          <div className="about__section-head">
            <p className="section-label">Hospital Tour</p>
            <h3 className="section-title">Take a quick tour inside CCIH</h3>
          </div>

          <div className="about__leadership-grid">
            {[
              { src: wellnessImg, alt: "Hospital facility" },
              { src: achieveImg, alt: "Hospital services" },
              { src: heroOne, alt: "Hospital campus" },
              { src: heroTwo, alt: "Hospital environment" },
            ].map((img) => (
              <div key={img.alt} className="card" style={{ overflow: "hidden" }}>
                <img
                  src={img.src}
                  alt={img.alt}
                  loading="lazy"
                  style={{ width: "100%", height: 220, objectFit: "cover", display: "block" }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
